import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type TimeSlotCardTimeSlotFragment = { __typename?: 'TimeSlot', startsAt: TimeString, endsAt: TimeString };

export const TimeSlotCardTimeSlotFragmentDoc = gql`
    fragment TimeSlotCardTimeSlot on TimeSlot {
  startsAt
  endsAt
}
    `;